import { useLocation } from "react-router"

import { NAV } from "@/components/shell"

export function NavPlaceholderRoute(): JSX.Element {
  const location = useLocation()
  const href = location.pathname

  const item = NAV.flatMap((g) => g.items).find(
    (i) => href === i.href || href.startsWith(`${i.href}/`),
  )

  const title = item?.label ?? "Coming soon"
  const hint = item?.hint ?? "This surface will land in a later phase."

  return (
    // Fills the entire main region edge-to-edge — no width cap, minimal
    // outer padding — so an empty placeholder never leaves a dead zone the
    // reviewer mistakes for a broken page. The card grows via flex-1; the
    // "coming soon" message is centered inside it.
    <div className="flex h-full w-full flex-col gap-5 px-6 py-5">
      <header className="min-w-0">
        <h1 className="text-subtitle text-text">{title}</h1>
        {hint && <p className="mt-0.5 text-body-sm text-text-3">{hint}</p>}
      </header>

      <section className="flex flex-1 flex-col items-center justify-center rounded-lg border border-dashed border-border bg-surface p-10 text-center shadow-e1">
        <h2 className="text-heading text-text">Not built yet</h2>
        <p className="mt-1 text-body-sm text-text-3">
          <code className="font-id text-text-2">{href}</code>
        </p>
      </section>
    </div>
  )
}
